export const CREATE_PAYMENT = 'CREATE_PAYMENT'
export const PAYMENT_RESPONSE = 'PAYMENT_RESPONSE'
export const PAYMENT_DETAILS = 'PAYMENT_DETAILS'
export const PAYMENT_DETAILS_RESPONSE = 'PAYMENT_DETAILS_RESPONSE'
export const REQUEST_CANCEL = 'REQUEST_CANCEL'
export const SUCCESS_PAYMENT = 'SUCCESS_PAYMENT'
export const UPDATE_MINUTES = 'UPDATE_MINUTES'
export const PAYMENT_FLAG = 'PAYMENT_FLAG'
export const PAYMENT_FLAG_RESPONSE = 'PAYMENT_FLAG_RESPONSE'
